import * as React from "react";
import { useTranslation } from "./i18n";
import About from "./About";
/*
 * Top-right control cluster: About and the language toggle. Rendered as a
 * floating rail so it's reachable on every screen.
 *
 * (The app is dark-only, so there is no theme toggle; the four-color-suit
 * toggle lives in the Settings pane.)
 */
var Toolbar = function () {
    var _a = useTranslation(), t = _a.t, lang = _a.lang, toggleLang = _a.toggleLang;
    var _b = React.useState(false), aboutOpen = _b[0], setAboutOpen = _b[1];
    var aboutLabel = lang === "zh" ? "关于" : "About";
    return (React.createElement("div", { className: "sj-rail fixed right-3 top-3 z-50 flex items-center gap-1 p-1" },
        React.createElement("button", { type: "button", className: "sj-btn sj-btn-ghost !min-h-[40px] !px-3 !text-[var(--text-primary)]", onClick: function () { return setAboutOpen(true); }, "aria-label": aboutLabel, title: aboutLabel },
            React.createElement("span", { "aria-hidden": "true" }, "\u2139\uFE0F")),
        React.createElement(About, { isOpen: aboutOpen, onRequestClose: function () { return setAboutOpen(false); } }),
        React.createElement("button", { type: "button", className: "sj-btn sj-btn-ghost !min-h-[40px] !px-3 !text-[var(--text-primary)]", onClick: toggleLang, "aria-label": t("toolbar.language"), title: t("toolbar.language") }, t("toolbar.language"))));
};
export default Toolbar;
